import { createSlice, createAsyncThunk, nanoid } from '@reduxjs/toolkit';

import { BajoAPI, fetchStatus } from '../../../api/client';
import { getAxiosRequestConfig } from '../../../common/common';
import { Operation } from '../../../common/constants';
import Collection from '../../../component/Controls/paginators/collection';
import { refreshCreated } from '../../../component/Controls/paginators/services/createdResource';
import { refreshRemoved } from '../../../component/Controls/paginators/services/removedResource';
import { toaster } from '../../../component/Controls/toasts/toaster';
import { isJSON } from '../../../utilities/utilityFunctions';

const initialState = {
    form: {
        status: fetchStatus.IDLE,
        error: null,
        data: undefined
    },
    data: {
        totalItems: 0,
        items: [],
        status: fetchStatus.IDLE,
        error: null,
        currentPage: 0,
        isFiltered: false,
        records: new Collection(),
        firstRecords: new Collection()
    },
    single: {
        status: fetchStatus.IDLE,
        error: null,
        data: undefined,
        refreshed: nanoid()
    },
    creation: {
        status: fetchStatus.IDLE,
        error: null,
        createdResource: undefined
    },
    modification: {
        status: fetchStatus.IDLE,
        error: null,
        modifiedResource: undefined
    },
    removal: {
        status: fetchStatus.IDLE,
        error: null,
        removedResource: undefined
    },
    skillGroupOptions: {
        status: fetchStatus.IDLE,
        error: null,
        options: undefined,
        refreshed: false
    },
    show: false,
    createMode: false,
    editMode: false,
};


export const getAllSkillGroup = createAsyncThunk('skillGroup/getAllSkillGroup', async (skillGroupModel, { rejectWithValue }) => {
    try {
        const response = await BajoAPI.post('Gateway', skillGroupModel.model, getAxiosRequestConfig());
        const data = response.data ? response.data.data : "[]";
        let skillGroup;
        if (isJSON(data)) {
            skillGroup = JSON.parse(data);
        }
        return {
            page: skillGroupModel.page,
            skillGroup: skillGroup,
            success: response.data.success
        };
    } catch (err) {
        return rejectWithValue(err.response.data)
    }

});

export const getSkillGroupById = createAsyncThunk('skillGroup/getSkillGroupById', async (skillGroupModel, { rejectWithValue }) => {
    try {
        const response = await BajoAPI.post(`Gateway`, skillGroupModel.model, getAxiosRequestConfig());
        const data = response.data ? response.data.data : undefined;
        let skillGroup = undefined;
        if (data && isJSON(data)) {
            skillGroup = JSON.parse(data);
        }
        return {
            page: skillGroupModel.page,
            skillGroup: skillGroup,
            success: response.data.success
        };
    } catch (err) {
        return rejectWithValue(err.response.data)
    }

});

export const createSkillGroup = createAsyncThunk('skillGroup/createSkillGroup', async (skillGroupModel, { rejectWithValue }) => {
    try {
        const response = await BajoAPI.post(`Gateway`, skillGroupModel, getAxiosRequestConfig());
        const data = response.data ? response.data.data : undefined;
        let skillGroup = undefined;
        if (data && isJSON(data)) {
            skillGroup = JSON.parse(data);
        }
        return {
            skillGroup: skillGroup,
            success: response.data.success
        };
    } catch (err) {
        return rejectWithValue(err.response.data)
    }

});

export const updateSkillGroup = createAsyncThunk('skillGroup/updateSkillGroup', async (skillGroupModel, { rejectWithValue }) => {
    try {
        const response = await BajoAPI.post(`Gateway`, skillGroupModel, getAxiosRequestConfig());
        const data = response.data ? response.data.data : undefined;
        let skillGroup = undefined;
        if (data && isJSON(data)) {
            skillGroup = JSON.parse(data);
        }
        return {
            skillGroup: skillGroup,
            success: response.data.success
        };
    } catch (err) {
        return rejectWithValue(err.response.data)
    }

});

export const removeSkillGroup = createAsyncThunk('skillGroup/removeSkillGroup', async (skillGroupModel, { rejectWithValue }) => {
    try {
        const response = await BajoAPI.post(`Gateway`, skillGroupModel, getAxiosRequestConfig());
        const data = response.data ? response.data.data : undefined;
        return {
            id: data,
            success: response.data.success
        };
    } catch (err) {
        return rejectWithValue(err.response.data)
    }

});

export const getSkillGroupOptions = createAsyncThunk('skillGroup/getSkillGroupOptions', async (skillGroupModel, { rejectWithValue }) => {
    const response = await BajoAPI.post('Gateway', skillGroupModel, getAxiosRequestConfig());
    const data = response.data ? response.data.data : "[]";
    let options;
    if (isJSON(data)) {
        options = JSON.parse(data);
    }
    return {
        options: options,
        success: response.data.success
    };
});


export const skillGrouplice = createSlice({
    name: 'skillGroup',
    initialState,
    reducers: {
        updateStatus: (state) => {
            state.data.status = fetchStatus.DONE;
        },
        updateSingleStatus: (state) => {
            state.single.status = fetchStatus.IDLE;
        },
        updateCreationStatus: (state) => {
            state.creation.status = fetchStatus.IDLE;
        },
        updateModificationStatus: (state) => {
            state.modification.status = fetchStatus.IDLE;
        },
        updateRemovalStatus: (state) => {
            state.removal.status = fetchStatus.IDLE;
        },
        updateCurrentPage: (state, page) => {
            state.data.currentPage = page.payload;
        },
        updateIsFiltered: (state) => {
            state.data.isFiltered = true;
        },
        loadSingleData: (state, _data) => {
            state.single.data = Object.assign({}, _data.payload);
        },
        updateSingleData: (state, _data) => {
            state.single.refreshed = nanoid();
            state.single.data = _data.payload ? Object.assign({}, _data.payload.skillGroup) : _data.payload;
            if (_data.payload && _data.payload.skillGroup) {
                if (_data.payload.operation === Operation.UPDATED) {
                    let _item = state.data.records.Get(state.data.currentPage);
                    if (_item && _item.records && Array.isArray(_item.records) && _item.records.length > 0) {
                        let _updatedObjectIndex = _item.records.findIndex(a => a.id === _data.payload.skillGroup.id);
                        let newRecords = _item.records;
                        let _skillGroup = {
                            id: _data.payload.skillGroup.id,
                            SkillGroupName: _data.payload.skillGroup.SkillGroupName.Data,
                        };
                        newRecords[_updatedObjectIndex] = _skillGroup;
                        _item.records = newRecords;
                        let records = new Collection();
                        records.Add(_item.key, newRecords);
                        state.data.records.Remove(_item.key);
                        records.Concat(state.data.records);
                        state.data.records = records;
                    }
                }
            }
        },
        createNewSkillGroup: state => {
            state.single.data = {
                "SkillGroupName": {
                    "Id": "txtSkillGroupName",
                    "Data": ""
                },
                "Status": {
                    "Id": "drpStatuses",
                    "Data": "Active"
                },
            };
        },
        createSkillGroupOptionDetail: (state) => {
            state.single.data.SkillGroupOptions = [...state.single.data.SkillGroupOptions, ''];
        },
        deleteSkillGroupOptionDetail: (state, action) => {
            const index = action.payload;
            state.single.data.SkillGroupOptions = state.single.data.SkillGroupOptions.filter((_, i) => i !== index);
        },
        updateSkillGroupOptionsStatus: (state) => {
            state.skillGroupOptions.status = fetchStatus.IDLE;
        },
        showSkillGroupFlyout: (state, action) => {
            const { createMode, editMode } = action.payload;
            state.createMode = createMode;
            state.editMode = editMode;
            state.show = true;
        },
        closeSkillGroupFlyout: (state, action) => {
            state.createMode = false;
            state.editMode = false;
            state.show = false;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getAllSkillGroup.pending, (state, action) => {
            state.data.status = fetchStatus.LOADING;
        })
            .addCase(getAllSkillGroup.fulfilled, (state, action) => {
                state.data.totalItems = action.payload.skillGroup.totalItems;
                state.data.items = action.payload.skillGroup.items;
                state.data.isFiltered = false;
                state.data.status = fetchStatus.SUCCEEDED;
                toaster.success(action.payload.success);
            })
            .addCase(getAllSkillGroup.rejected, (state, action) => {
                state.data.status = fetchStatus.FAILED;
                state.data.error = action.error.message;
                toaster.error(action.payload ? action.payload.error : "");
            }).addCase(getSkillGroupById.pending, (state, action) => {
                state.single.status = fetchStatus.LOADING;
            }).addCase(getSkillGroupById.fulfilled, (state, action) => {
                state.single.data = action.payload.skillGroup;
                if (action.payload.page >= 0) {
                    let _records = new Collection();
                    _records.Add(action.payload.page, action.payload.skillGroup);
                    _records.Concat(state.data.firstRecords);
                    state.data.firstRecords = _records;
                }
                state.single.status = fetchStatus.SUCCEEDED;
                toaster.success(action.payload.success);
            }).addCase(getSkillGroupById.rejected, (state, action) => {
                state.single.status = fetchStatus.FAILED;
                state.single.error = action.error.message;
                toaster.error(action.payload ? action.payload.error : "");
            }).addCase(createSkillGroup.pending, (state, action) => {
                state.creation.status = fetchStatus.LOADING;
            }).addCase(createSkillGroup.fulfilled, (state, action) => {
                if (action.payload.skillGroup) {
                    state.single.data = action.payload.skillGroup;
                    let _skillGroup = {
                        id: action.payload.skillGroup.id,
                        SkillGroupName: action.payload.skillGroup.SkillGroupName.Data,
                        // Type: action.payload.skillGroup.Type.Data,
                        Status: action.payload.skillGroup.Status.Data
                    };
                    const created = refreshCreated(state.data.records, _skillGroup);
                    state.data.records = created.records;
                    state.data.currentPage = created.lastPage;
                    state.data.totalItems += 1;
                    state.single.refreshed = nanoid();
                }
                state.creation.status = fetchStatus.SUCCEEDED;
                toaster.success(action.payload.success);
            }).addCase(createSkillGroup.rejected, (state, action) => {
                state.creation.status = fetchStatus.FAILED;
                state.creation.error = action.error.message;
                toaster.error(action.payload ? action.payload.error : "");
            }).addCase(updateSkillGroup.pending, (state, action) => {
                state.modification.status = fetchStatus.LOADING;
            }).addCase(updateSkillGroup.fulfilled, (state, action) => {
                state.single.data = action.payload.skillGroup;
                state.modification.status = fetchStatus.SUCCEEDED;
                toaster.success(action.payload.success);
            }).addCase(updateSkillGroup.rejected, (state, action) => {
                state.modification.status = fetchStatus.FAILED;
                state.modification.error = action.error.message;
                toaster.error(action.payload ? action.payload.error : "");
            }).addCase(removeSkillGroup.pending, (state, action) => {
                state.removal.status = fetchStatus.LOADING;
            }).addCase(removeSkillGroup.fulfilled, (state, action) => {
                const removed = refreshRemoved(state.data.records, action.payload.id, state.data.currentPage);
                state.data.records = removed.records;
                state.data.currentPage = removed.lastPage;
                state.data.totalItems -= 1;
                state.single.refreshed = nanoid();
                state.removal.status = fetchStatus.SUCCEEDED;
                toaster.success(action.payload.success);
            }).addCase(removeSkillGroup.rejected, (state, action) => {
                state.removal.status = fetchStatus.FAILED;
                state.removal.error = action.error.message;
                toaster.error(action.payload ? action.payload.error : "");
            }).addCase(getSkillGroupOptions.pending, (state, action) => {
                state.skillGroupOptions.status = fetchStatus.LOADING;
            }).addCase(getSkillGroupOptions.fulfilled, (state, action) => {
                let _options = action.payload.options;
                _options = _options.map(function (option) {
                    option['value'] = option['id'];
                    delete option['id'];
                    option['text'] = option['SkillGroupName'];
                    delete option['SkillGroupName'];
                    return option;
                });
                state.skillGroupOptions.options = _options;
                state.skillGroupOptions.status = fetchStatus.SUCCEEDED;
                state.skillGroupOptions.refreshed = false;
                toaster.success(action.payload.success);
            }).addCase(getSkillGroupOptions.rejected, (state, action) => {
                state.skillGroupOptions.status = fetchStatus.FAILED;
                state.skillGroupOptions.error = action.error.message;
                toaster.error(action.payload ? action.payload.error : "");
            });

    }
});

export const { updateCreationStatus, updateModificationStatus, updateRemovalStatus,
    updateSingleStatus, updateIsFiltered, updateStatus, loadSingleData,
    updateCurrentPage, updateSingleData, createNewSkillGroup, createSkillGroupOptionDetail, deleteSkillGroupOptionDetail,
    updateSkillGroupOptionsStatus,
    showSkillGroupFlyout, closeSkillGroupFlyout } = skillGrouplice.actions;

export default skillGrouplice.reducer


export const selectAllSkillGroup = state => state.skillGroup.data.items;
export const selectTotalItems = state => state.skillGroup.data.totalItems;
export const selectStatus = state => state.skillGroup.data.status;

export const selectCreationStatus = state => state.skillGroup.creation.status;

export const selectModificationStatus = state => state.skillGroup.modification.status;

export const selectRemovalStatus = state => state.skillGroup.removal.status;

export const selectSkillGroupById = (state) => {
    return state.skillGroup.single ? state.skillGroup.single.data : undefined;
}
export const selectSingleStatus = state =>  state.skillGroup.single.status;

export const selectSkillGroupFormStatus = state => state.skillGroup.form.status;
export const selectSkillGroupFormError = state => state.skillGroup.form.error;
export const selectSkillGroupForm = state => state.skillGroup.form.data;

export const selectSkillGroupOptionsStatus = state => state.skillGroup.skillGroupOptions.status;
export const selectSkillGroupOptions = state => state.skillGroup.skillGroupOptions.options;

export const selectSkillGroupFlyoutShow = state => state.skillGroup.show;
export const selectSkillGroupFlyoutCreateMode = state => state.skillGroup.createMode;
export const selectSkillGroupFlyoutEditmode = state => state.skillGroup.editMode;